import React, { useEffect, useState, useMemo } from "react";
import "rsuite/dist/rsuite.min.css";
import { useDispatch, useSelector } from "react-redux";
import {
    getIdCardListAction,
    setIdCardListStatus,
    setGeoLoactionStateAction,
    setZoneActions,
    setRegionActions,
    setClientBranchSearchAction,
    resetOrganizationFilterlist,
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import Select from "react-select";
import { DateRangePicker } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import _ from "lodash";
import useDebouncedEffect from "use-debounced-effect";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { IdCardGenerateApi } from "../../../text/apidata";

const IdCardList = () => {
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive,
    );
    const dispatch = useDispatch();
    const state = useSelector((state) => state);
    const [dtpageindex, setdtPageindex] = useState(1);
    const [dtpagesize, setdtPagesize] = useState(20);
    const [search, setsearch] = useState("");
    // timeline ids picked for generation, kept across pages until generated
    const [selectedIds, setSelectedIds] = useState([]);
    const [generating, setGenerating] = useState(false);
    const navigate = useNavigate();
    const [refreshKey, setRefreshKey] = useState(0);

    const [nameList, setOptions] = useState([]);
    const [nameList2, setOptions2] = useState([]);
    const [nameList5, setOptions5] = useState([]);
    const [nameList4, setOptions4] = useState([]);
    const [organizationOptions, setOrganizationOptions] = useState([]);

    const initialStateSearch = {
        stateSearch: "",
        regionSearch: "",
        zoneSearch: "",
    };
    const [SearchedVal, setSearched] = useState(initialStateSearch);
    const [SearchDebounance, setSearchDebounance] = useState({
        ...initialStateSearch,
        Clientsearch: "",
    });
    const [searchBranch, setSearch] = useState("");

    const [multiselect, setMuliselect] = useState({ value: "", label: "ALL" });
    const [multiselect1, setMuliselect1] = useState({ value: "", label: "ALL" });
    const [multiselect3, setMuliselect3] = useState({ value: "", label: "ALL" });
    const [Client_Val, setClient_Val] = useState({ value: "", label: "ALL" });
    const [Organization_Val, setOrganization_Val] = useState({ value: "", label: "ALL" });

    const [datas, setData] = useState({
        state: "",
        region: "",
        zone: "",
        client: "",
    });
    const [organization, setOrganization] = useState("");

    // no default date, the list loads only after the user picks a range
    const [range, setrange] = useState([]);
    const hasRange = range.length === 2 && !range.includes("NaN-aN-aN");

    const statusValue = state.idCardList?.status;
    const options = [
        { value: "", label: "All" },
        { value: "pending", label: "Pending" },
        { value: "completed", label: "Completed" },
    ];

    // status is persisted in the store, so start every visit from All
    useEffect(() => {
        dispatch(setIdCardListStatus({ value: "", label: "All" }));
    }, []);

    ///-----------List---------------
    useEffect(() => {
        if (hasRange) {
            const payloads = {
                search: search,
                page_size: dtpagesize,
                page: dtpageindex,
                status: statusValue?.value,
                state: datas.state,
                region: datas.region,
                zone: datas.zone,
                client: datas.client,
                organization: organization,
                from_date: range[0],
                to_date: range[1],
            };
            dispatch(getIdCardListAction(payloads));
        }
    }, [search, dtpageindex, dtpagesize, range, datas, organization, statusValue, refreshKey]);

    // a filter change can hide selected rows, so start the selection over
    useEffect(() => {
        setSelectedIds([]);
    }, [search, range, datas, organization, statusValue]);

    ///--------------Selection / Generate-----------------
    // store can still hold an earlier visit's list, show nothing until a range is picked
    const listData = hasRange && state.idCardList?.idCardListData?.length > 0
        ? state.idCardList?.idCardListData
        : [];
    const totalCount = hasRange ? state.idCardList?.Total_Count || 0 : 0;
    // already generated cards are never regenerated, so only pending rows are selectable
    const selectableIds = listData
        .filter((item) => item?.is_card_generated != true)
        .map((item) => item.id);
    const allPageSelected =
        selectableIds.length > 0 && selectableIds.every((id) => selectedIds.includes(id));

    const toggleRow = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
        );
    };

    const togglePage = () => {
        setSelectedIds((prev) =>
            allPageSelected
                ? prev.filter((id) => !selectableIds.includes(id))
                : _.union(prev, selectableIds),
        );
    };

    const handleGenerate = () => {
        if (selectedIds.length === 0 || generating) {
            return;
        }
        setGenerating(true);
        axios({
            method: "post",
            url: IdCardGenerateApi,
            data: { ids: selectedIds },
            headers: {
                Authorization: "Bearer " + state.users.UserData.session.token,
            },
        })
            .then((response) => {
                toast.success(response.data?.message || "ID card generation started", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setSelectedIds([]);
                // cards are generated in the background, refresh the list once they are likely done
                setRefreshKey((prev) => prev + 1);
                setTimeout(() => setRefreshKey((prev) => prev + 1), 5000);
            })
            .catch((error) => {
                toast.error(error?.response?.data?.message || "Something went wrong", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                if (error?.response?.status == 401) {
                    localStorage.clear();
                    window.location.href = "/";
                }
            })
            .finally(() => setGenerating(false));
    };

    ///--------------Client-----------------
    useEffect(() => {
        const payload = {
            search: searchBranch,
            page_size: 30,
            page: 1,
            data: datas,
            organization: organization,
        };
        dispatch(setClientBranchSearchAction(payload));
    }, [searchBranch, datas.state, datas.region, datas.zone, organization]);

    useEffect(() => {
        if (state.BranchSearchpart.BranchSearch != undefined) {
            let objectArray = [{ value: "", label: "ALL" }];
            state.BranchSearchpart.BranchSearch.forEach((element) => {
                objectArray.push({
                    value: element.id,
                    label: element.client_name.toUpperCase(),
                });
            });
            setOptions4(objectArray);
        }
    }, [state.BranchSearchpart.BranchSearch]);

    ///--------------Organization-----------------
    useEffect(() => {
        const payloads = {
            search: "",
            page_size: 100,
            page: 1,
        };
        dispatch(resetOrganizationFilterlist(payloads));
    }, []);

    useEffect(() => {
        const records = state.organization_filterlist_tocall?.Organization_filterlist_records;
        if (records != undefined) {
            // ID cards are issued only for these organizations
            const allowed = ["uds", "sony", "stanworth"];
            let objectArray = [{ value: "", label: "ALL" }];
            records.forEach((element) => {
                const name = (element.organization_name || "").toLowerCase();
                if (allowed.some((item) => name.includes(item))) {
                    objectArray.push({
                        value: element.id,
                        label: element.organization_name.toUpperCase(),
                    });
                }
            });
            setOrganizationOptions(objectArray);
        }
    }, [state.organization_filterlist_tocall?.Organization_filterlist_records]);

    ///--------------State-----------------
    useEffect(() => {
        const payloads = {
            search: SearchedVal.stateSearch,
            page_size: "",
            page: 1,
        };
        dispatch(setGeoLoactionStateAction(payloads));
    }, [SearchedVal.stateSearch]);

    useEffect(() => {
        if (state.GeoState.State != undefined) {
            let objectArray = [{ value: "", label: "ALL" }];
            state.GeoState.State.forEach((element) => {
                objectArray.push({
                    value: element.id,
                    label: element.state_name.toUpperCase(),
                });
            });
            setOptions(objectArray);
        }
    }, [state.GeoState.State]);

    ///--------------Region-----------------
    useEffect(() => {
        const payloads = {
            search: SearchedVal.regionSearch,
            page_size: 20,
            page: 1,
            counts: 1,
            state: datas.state,
        };
        dispatch(setRegionActions(payloads));
    }, [datas.state, SearchedVal.regionSearch]);

    useEffect(() => {
        if (state.regioncall.RegionDat != undefined) {
            let objectArray = [{ value: "", label: "ALL" }];
            state.regioncall.RegionDat.forEach((element) => {
                objectArray.push({
                    value: element.id,
                    label: element.region_name.toUpperCase(),
                });
            });
            setOptions2(objectArray);
        }
    }, [state.regioncall.RegionDat]);

    ///--------------Zone-----------------
    useEffect(() => {
        const payloads = {
            search: SearchedVal.zoneSearch,
            page_size: 20,
            page: 1,
            counts: 1,
            region_id: datas.region,
        };
        dispatch(setZoneActions(payloads));
    }, [datas.region, SearchedVal.zoneSearch]);

    useEffect(() => {
        if (state.ZonePart.Zone != undefined) {
            let objectArray = [{ value: "", label: "ALL" }];
            state.ZonePart.Zone.forEach((element) => {
                objectArray.push({
                    value: element.id,
                    label: element.zone_name.toUpperCase(),
                });
            });
            setOptions5(objectArray);
        }
    }, [state.ZonePart.Zone]);

    useDebouncedEffect(
        () => {
            setSearched({
                ...SearchedVal,
                stateSearch: SearchDebounance.stateSearch,
                regionSearch: SearchDebounance.regionSearch,
                zoneSearch: SearchDebounance.zoneSearch,
            });
            setSearch(SearchDebounance.Clientsearch);
        },
        500,
        [SearchDebounance],
    );

    ///--------------Filter handlers-----------------
    const resetClient = () => {
        setClient_Val({ value: "", label: "ALL" });
    };

    const handleSelectChange = (selectedVal) => {
        setdtPageindex(1);
        resetClient();
        setMuliselect(selectedVal != null ? selectedVal : { value: "", label: "ALL" });
        setMuliselect1({ value: "", label: "ALL" });
        setMuliselect3({ value: "", label: "ALL" });
        setData({
            ...datas,
            state: selectedVal != null ? selectedVal.value : "",
            region: "",
            zone: "",
            client: "",
        });
    };

    const handelRegionSlect = (selectedVal) => {
        setdtPageindex(1);
        resetClient();
        setMuliselect1(selectedVal != null ? selectedVal : { value: "", label: "ALL" });
        setMuliselect3({ value: "", label: "ALL" });
        setData({
            ...datas,
            region: selectedVal != null ? selectedVal.value : "",
            zone: "",
            client: "",
        });
    };

    const handleZone = (selectedVal) => {
        setdtPageindex(1);
        resetClient();
        setMuliselect3(selectedVal != null ? selectedVal : { value: "", label: "ALL" });
        setData({
            ...datas,
            zone: selectedVal != null ? selectedVal.value : "",
            client: "",
        });
    };

    const handleOrganization = (selectedVal) => {
        setdtPageindex(1);
        resetClient();
        setOrganization_Val(selectedVal != null ? selectedVal : { value: "", label: "ALL" });
        setOrganization(selectedVal != null ? selectedVal.value : "");
        setData({
            ...datas,
            client: "",
        });
    };

    const HandleClientBranches = (selectedVal) => {
        setdtPageindex(1);
        setClient_Val(selectedVal != null ? selectedVal : { value: "", label: "ALL" });
        setData({
            ...datas,
            client: selectedVal != null ? selectedVal.value : "",
        });
    };

    const handleInputChange = (Val) => {
        setSearchDebounance({ ...SearchDebounance, stateSearch: Val });
    };
    const handleInputRegion = (Val) => {
        setSearchDebounance({ ...SearchDebounance, regionSearch: Val });
    };
    const handleInputZone = (Val) => {
        setSearchDebounance({ ...SearchDebounance, zoneSearch: Val });
    };
    const HandleInputBranch = (Val) => {
        setSearchDebounance({ ...SearchDebounance, Clientsearch: Val });
    };

    ///--------------Status (table filter)-----------------
    const count = (Counts, values, sel, SelectedValues) => {
        setdtPageindex(1);
        dispatch(
            setIdCardListStatus({
                value: SelectedValues.value,
                label: SelectedValues.label,
            }),
        );
    };

    const ClearState = () => {
        setdtPageindex(1);
        dispatch(setIdCardListStatus({ value: "", label: "All" }));
    };

    ///--------------Table paging / search-----------------
    const pagesize = (arg) => {
        setdtPagesize(arg);
    };

    const pageindex = (arg) => {
        setdtPageindex(arg);
    };

    const debouncedSearch = useMemo(
        () =>
            _.debounce((e) => {
                setsearch(e);
            }, 500),
        [],
    );
    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    function tochange(e) {
        setdtPageindex(1);
        debouncedSearch(e);
    }

    const handleNext = (next) => {
        setdtPageindex(next + 1);
    };

    const GotoEnteredPage = (gotopage) => {
        setdtPageindex(gotopage);
    };

    const handlePrevious = (previous) => {
        if (previous != 0) {
            setdtPageindex(previous);
        }
    };

    const predefinedBottomRanges = [
        {
            label: "Today",
            value: [new Date(), new Date()],
            placement: "left",
        },
        {
            label: "Yesterday",
            value: [addDays(new Date(), -1), addDays(new Date(), -1)],
            placement: "left",
        },
        {
            label: "This week",
            value: [startOfWeek(new Date()), endOfWeek(new Date())],
            placement: "left",
        },
        {
            label: "Last week",
            value: (value, index) => {
                const [start = new Date()] = value[index] || [];
                return [
                    addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
                    addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
                ];
            },
            placement: "left",
        },
        {
            label: "Last 30 days",
            value: [subDays(new Date(), 29), new Date()],
            placement: "left",
        },
    ];

    const formatDateTime = (value) => {
        if (!value) {
            return "---";
        }
        const date = new Date(value);
        const dd = ("0" + date.getDate()).slice(-2);
        const mm = ("0" + (date.getMonth() + 1)).slice(-2);
        const hh = ("0" + date.getHours()).slice(-2);
        const min = ("0" + date.getMinutes()).slice(-2);
        return `${dd}-${mm}-${date.getFullYear()} ${hh}:${min}`;
    };

    const columns = useMemo(
        () => [
            {
                Header: () => (
                    <input
                        type="checkbox"
                        checked={allPageSelected}
                        disabled={selectableIds.length === 0}
                        onChange={togglePage}
                        title="Select all pending on this page"
                    />
                ),
                id: "select",
                accessor: "",
                Cell: (row) => {
                    const id = row.row.original?.id;
                    const generated = row.row.original?.is_card_generated == true;
                    return (
                        <input
                            type="checkbox"
                            checked={!generated && selectedIds.includes(id)}
                            disabled={generated}
                            onClick={(e) => e.stopPropagation()}
                            onChange={() => toggleRow(id)}
                        />
                    );
                },
            },
            {
                Header: "S.No",
                accessor: "",
                Cell: (row) => {
                    return (
                        <p className="PTAGs">
                            {(dtpageindex - 1) * dtpagesize + row.row.index + 1}
                        </p>
                    );
                },
            },
            {
                Header: "Emp Code",
                accessor: "",
                Cell: (row) => {
                    return (
                        <div className="UserName">
                            <span className="KYcRoles">
                                {row.row.original?.user_id?.user_uid || "---"}
                            </span>
                        </div>
                    );
                },
            },
            {
                Header: "Employee Name",
                accessor: "",
                Cell: (row) => {
                    const employeeName = [
                        row.row.original?.user_id?.first_name,
                        row.row.original?.user_id?.last_name,
                    ]
                        .filter(Boolean)
                        .join(" ");
                    return (
                        <div className="UserName">
                            <span className="KYcRoles">
                                {employeeName || "---"}
                            </span>
                        </div>
                    );
                },
            },
            {
                Header: "Phone Number",
                accessor: "",
                Cell: (row) => {
                    return (
                        <div className="UserName">
                            <span className="KYcRoles">
                                {row.row.original?.user_id?.phone_number || "---"}
                            </span>
                        </div>
                    );
                },
            },
            {
                Header: "Client Name",
                accessor: "",
                Cell: (row) => {
                    return (
                        <div className="UserName">
                            <span className="KYcRoles">
                                {row.row.original?.client_name || "---"}
                            </span>
                        </div>
                    );
                },
            },
            {
                Header: "Client Zone",
                accessor: "",
                Cell: (row) => {
                    return (
                        <div className="UserName">
                            <span className="KYcRoles">
                                {row.row.original?.client_zone || "---"}
                            </span>
                        </div>
                    );
                },
            },
            {
                Header: "ID Card Status",
                accessor: "",
                Cell: (row) => {
                    const generated = row.row.original?.is_card_generated == true;
                    return (
                        <div className="UserName">
                            <span
                                className="KYcRoles"
                                style={{ color: generated ? "green" : "red" }}
                            >
                                {generated ? "Completed" : "Pending"}
                            </span>
                        </div>
                    );
                },
            },
            {
                Header: "Generated At",
                accessor: "",
                Cell: (row) => {
                    return (
                        <p className="PTAGs">
                            {formatDateTime(row.row.original?.id_card_generated_at)}
                        </p>
                    );
                },
            },
            {
                Header: "ID Card",
                accessor: "",
                Cell: (row) => {
                    const idCard = row.row.original?.id_card;
                    return (
                        <div className="UserName">
                            {idCard ? (
                                <a
                                    href={idCard}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="KYcRoles"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    View
                                </a>
                            ) : (
                                <span className="KYcRoles">---</span>
                            )}
                        </div>
                    );
                },
            },
        ],
        [dtpageindex, dtpagesize, selectedIds, listData],
    );

    return (
        <>
            <div className={stateDisplay ? "outterContent" : "inner-Content"}>
                <div
                    className="Header-Details ClientBranch row"
                    style={{ padding: "14px 28px" }}
                >
                    <div
                        class="col-sm-7 auto"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                        }}
                    >
                        <h3 class="user-name mb-0">ID Card</h3>
                        <br />
                    </div>
                </div>
                <div
                    className="row Filters "
                    style={{
                        marginRight: "0px",
                        marginLeft: "0px",
                        padding: "0px 30px",
                        zIndex: "89",
                    }}
                >
                    <div className="col-sm-2" style={{ marginTop: "-19px", zIndex: "99" }}>
                        <label for="validationCustom01" class="form-label" style={{ fontSize: "19px" }}>
                            State
                        </label>
                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onChange={(e) => {
                                handleSelectChange(e);
                            }}
                            options={nameList}
                            onInputChange={handleInputChange}
                            isClearable={true}
                            value={multiselect}
                            labelledBy="Select"
                        />
                    </div>

                    <div className="col-sm-2" style={{ marginTop: "-19px", zIndex: 3 }}>
                        <label for="validationCustom01" class="form-label" style={{ fontSize: "19px" }}>
                            Region
                        </label>
                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onChange={(e) => {
                                handelRegionSlect(e);
                            }}
                            options={nameList2}
                            labelledBy="Select"
                            isClearable={true}
                            value={multiselect1}
                            onInputChange={handleInputRegion}
                        />
                    </div>

                    <div className="col-sm-2" style={{ marginTop: "-19px" }}>
                        <label for="validationCustom01" class="form-label" style={{ fontSize: "19px" }}>
                            Zone
                        </label>
                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onChange={(e) => {
                                handleZone(e);
                            }}
                            value={multiselect3}
                            options={nameList5}
                            isClearable={true}
                            labelledBy="Select"
                            onInputChange={handleInputZone}
                        />
                    </div>

                    <div className="col-sm-2" style={{ zIndex: "21", marginTop: "-19px" }}>
                        <label for="validationCustom01" class="form-label" style={{ fontSize: "19px" }}>
                            Organization
                        </label>
                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onChange={(e) => {
                                handleOrganization(e);
                            }}
                            options={organizationOptions}
                            labelledBy="Select"
                            isClearable={true}
                            value={Organization_Val}
                        />
                    </div>

                    <div className="col-sm-2" style={{ zIndex: "20", marginTop: "-19px" }}>
                        <label for="validationCustom01" class="form-label" style={{ fontSize: "19px" }}>
                            Client
                        </label>
                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onChange={(e) => {
                                HandleClientBranches(e);
                            }}
                            options={nameList4}
                            labelledBy="Select"
                            onInputChange={HandleInputBranch}
                            isClearable={true}
                            value={Client_Val}
                        />
                    </div>

                    <div className="col-sm-2 SelectedDate" style={{ marginTop: "-21px" }}>
                        <label
                            for="validationCustom01 "
                            class="form-label"
                            style={{ fontSize: "19px", width: "100%" }}
                        >
                            Select Date
                            <span style={{ color: "red" }}>*</span>
                        </label>

                        <div className="datepicker_dash">
                            <DateRangePicker
                                components={{
                                    ClearButton: () => null,
                                }}
                                disabledDate={(date) => isAfter(date, new Date())}
                                editable={false}
                                appearance="default"
                                placement="bottomEnd"
                                size="lg"
                                ranges={predefinedBottomRanges}
                                placeholder="From - To"
                                onChange={(e) => {
                                    if (e != null) {
                                        let newRanges = [];
                                        e.forEach((newValue) => {
                                            var tzoffset = new Date().getTimezoneOffset() * 60000;
                                            var localISOTime = new Date(newValue - tzoffset)
                                                .toISOString()
                                                .slice(0, -1);
                                            newRanges.push(localISOTime.split("T")[0]);
                                        });
                                        setdtPageindex(1);
                                        setrange(newRanges);
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div style={{ padding: " 30px 40px", marginTop: "-13px" }}>
                    <ReactTable
                        data={listData}
                        columns={columns}
                        filterRowAction={
                            <div style={{ display: "flex", gap: "12px" }}>
                            <button
                                onClick={() => {
                                    // export runs as a report: open the create popup with the ID card report preselected
                                    navigate("/reportsheet", {
                                        state: {
                                            openCreate: true,
                                            reportType: "id_card_report",
                                        },
                                    });
                                }}
                                className="ButtonCSS"
                                style={{
                                    background: "#fff",
                                    color: "#F15D39",
                                    padding: "10px 28px",
                                    borderRadius: "6px",
                                    border: "1px solid #F15D39",
                                    fontWeight: 600,
                                    whiteSpace: "nowrap",
                                }}
                            >
                                Export
                            </button>
                            <button
                                onClick={handleGenerate}
                                disabled={selectedIds.length === 0 || generating}
                                className="ButtonCSS"
                                style={{
                                    background: "#F15D39",
                                    color: "#fff",
                                    opacity: selectedIds.length === 0 || generating ? 0.6 : 1,
                                    padding: "10px 28px",
                                    borderRadius: "6px",
                                    border: "none",
                                    fontWeight: 600,
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {generating
                                    ? "Generating..."
                                    : `Generate ID Card${selectedIds.length > 0 ? ` (${selectedIds.length})` : ""}`}
                            </button>
                            </div>
                        }
                        currentPage={1}
                        totalItems={totalCount}
                        pagesize={pagesize}
                        dtpagesize={dtpagesize}
                        pageindex={pageindex}
                        datacount={totalCount}
                        onChange={tochange}
                        dtpageindex={dtpageindex}
                        Filter={true}
                        values={statusValue}
                        options={options}
                        count={count}
                        ClearState={ClearState}
                        ApproveRequestFilter={true}
                        onPrevious={handlePrevious}
                        onNextpage={handleNext}
                        GotoEnteredPage={GotoEnteredPage}
                        search_key={true}
                    />
                </div>
            </div>
        </>
    );
};

export default IdCardList;
